import axiosInstance from "../../../helpers/api";

export const getAllSubjects = (body) => {
  return axiosInstance.get("/subjects", body);
};

export const getAllTeachers = (body) => {
  return axiosInstance.get("/teachers", body);
};

export const getTeacher = (id) => {
  return axiosInstance.get(`/teachers/${id}`);
};

export const getTeacherCourses = (id, userId) => {
  if (userId) {
    return axiosInstance.get(`/courses/teacher/${id}?user_id=${userId}`);
  }
  return axiosInstance.get(`/courses/teacher/${id}`);
};
